export default __webpack_public_path__ + "static/media/Disney Investory Day.29f38279.jpg";